import type { ConversationDigestApiModel } from "@noa/api-core";
import cn from "classnames";
import type { FunctionComponent } from "react";
import { Link } from "react-router";
import { useSessionId } from "@noa/client-store";
import { useConversationTitle } from "@noa/ui";

interface ConversationHistoryCompactItemProps {
  conversationSummary: ConversationDigestApiModel;
  onSelect?: () => void;
}

export const ConversationHistoryCompactItem: FunctionComponent<ConversationHistoryCompactItemProps> = ({
  conversationSummary,
  onSelect,
}) => {
  const selectedSessionId = useSessionId();

  const isActive = selectedSessionId === conversationSummary.session_id;
  const { title: conversationTitle } = useConversationTitle(conversationSummary);

  return (
    <Link
      to={`/conversation/${conversationSummary.session_id}`}
      onClick={onSelect}
      title={conversationTitle}
      className={cn(
        "block truncate rounded-md px-3 py-1.5 text-sm text-noa no-underline hover:bg-noa-hover",
        isActive && "bg-noa-hover"
      )}
    >
      {conversationTitle}
    </Link>
  );
};
